import {
    PRODUCT_CREATE_REQUEST,
    PRODUCT_CREATE_SUCCESS,
    PRODUCT_CREATE_FAIL,
    PRODUCT_CREATE_RESET,

    PRODUCT_IMPORT_REQUEST,
    PRODUCT_IMPORT_PROGRESS,
    PRODUCT_IMPORT_SUCCESS,
    PRODUCT_IMPORT_FAIL,
    PRODUCT_IMPORT_RESET,

    ALL_PRODUCTS_REQUEST,
    ALL_PRODUCTS_SUCCESS,
    ALL_PRODUCTS_FAIL,


    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAIL,
    UPDATE_PRODUCT_RESET,

    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAIL,
    DELETE_PRODUCT_RESET,



    SINGLE_PRODUCT_REQUEST,
    SINGLE_PRODUCT_SUCCESS,
    SINGLE_PRODUCT_FAIL,

    CLEAR_ERRORS
} from "../constants/productConstants";

export const productReducer = (state = {}, action) => {
    switch (action.type) {

        // ===============================
        // CREATE PRODUCT
        // ===============================
        case PRODUCT_CREATE_REQUEST:
            return {
                ...state,
                loading: true,
                importProgress: 0,
                inserted: 0,
                skipped: 0,

            };

        case PRODUCT_CREATE_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload
            };

        case PRODUCT_CREATE_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case PRODUCT_CREATE_RESET:
            return {};

        // ===============================
        // IMPORT PRODUCTS
        // ===============================
        case PRODUCT_IMPORT_REQUEST:
            return {
                loading: true,
                importProgress: 0
            };

        case PRODUCT_IMPORT_PROGRESS:
            return {
                ...state,
                importProgress: action.payload.percent,
                inserted: action.payload.inserted,
                skipped: action.payload.skipped

            };

        case PRODUCT_IMPORT_SUCCESS:
            return {
                loading: false,
                importSuccess: true,
                message: action.payload.message,
                inserted: action.payload.inserted,
                skipped: action.payload.skipped


            };

        case PRODUCT_IMPORT_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case PRODUCT_IMPORT_RESET:
            return {};

        // ===============================
        // CLEAR ERRORS
        // ===============================
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};
export const updateProductReducer = (state = {}, action) => {
    switch (action.type) {


        case UPDATE_PRODUCT_REQUEST:
        case DELETE_PRODUCT_REQUEST:
            return { ...state, loading: true };

        case UPDATE_PRODUCT_SUCCESS:
        case DELETE_PRODUCT_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload.message
            };

        case UPDATE_PRODUCT_FAIL:
        case DELETE_PRODUCT_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case UPDATE_PRODUCT_RESET:
        case DELETE_PRODUCT_RESET:
            return {};


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};


export const allProductsReducer = (state = {}, action) => {
    switch (action.type) {

        case ALL_PRODUCTS_REQUEST:
        case SINGLE_PRODUCT_REQUEST:
            return { ...state, loading: true };

        case ALL_PRODUCTS_SUCCESS:
            return {
                loading: false,
                success: true,
                products: action.payload.products,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalProducts: action.payload.totalProducts,
            };
        case SINGLE_PRODUCT_SUCCESS:
            return {
                loading: false,
                success: true,
                product: action.payload.product,
            };

        case ALL_PRODUCTS_FAIL:
        case SINGLE_PRODUCT_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};
